export const getInitialState = () => ({
  error: false,
  completed: false,
  started: false,
  pausedTime: null,
  duration: 0,
  progressPercentage: 0,
});
